import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
// import { ManageLibraryComponent } from '../manage-library/manage-library.component';
// import { ManageLibraryComponent } from 'src/app/admin/manage-library/manage-library.component';
import { FunctionService } from 'vhobjects-service';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'atw-page-admin-config',
  templateUrl: './page-admin-config.component.html',
  styleUrls: ['./page-admin-config.component.scss']
})
export class AtwPageAdminConfig implements OnInit {
  @Input() detailCurrentPage: any;
  @Input() blocks_of_page: any;
  @Input() selectedDevice;
  @Input() freeblocks;
  @Input() type = 'page';
  

  @Output() closeConfig = new EventEmitter<any>();
  public optionsBackground = [
    {
      label: 'Hình nền',
      value: 'image',
    },
    {
      label: 'Màu nền',
      value: 'color',
    },
  ];
  config: any = {};
  class: any = {};
  staticdata: any = {};
  effect_hover = [];
  effect_hover_data: any = {};
  customize = [];
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  style_fields = [
    {
      title: "cau_hinh_hieu_ung",
      index: 1
    },
    {
      title: "cau_hinh_mau_gradient",
      index: 2
    },
  ];
  transparent: boolean;
  background: boolean;
  isCollapsed: boolean = false;
  idHeaderMain: any;
  blockChatbox: any;
  blockPopupWelcome: any;
  configMode: 'basic' | 'advanced' = 'basic';
  resolution;
  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image
  isOpenOptionsBorder: boolean;
  subproject: any;
  type_upload: number = 1;
  image_choosing: any;
  configUpdates = {
    "animation-selected": { id: "000000" },
    "animation_delay_page": 0,
  }
  staticdataUpdates = {
    "tablet_portrait_animation": {
      "animation-0": {}
    },
    "mobile_portrait_animation": {
      "animation-0": {}
    },
    "mobile_landscape_animation": {
      "animation-0": {}
    },
    "tablet_portrait_animation_type": "none",
    "tablet_landscape_animation_type": "none",
    "tablet_landscape_animation": {
      "animation-0": {}
    },
    "mobile_portrait_animation_type": "none",
    "mobile_landscape_animation_type": "none",
    "desktop_animation": {
      "animation-0": {}
    },
    "desktop_animation_type": "none"
  }

  
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    private matdialog: MatDialog,
    public functionService: FunctionService,
    private nzContextMenuService: NzContextMenuService,
    private dialog: MatDialog,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.resolution = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    ).resolution;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject_Working();
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/page.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.config = this.detailCurrentPage[this.selectedDevice + '_config'];
      this.class = this.detailCurrentPage[this.selectedDevice + '_class'];
      this.staticdata = this.detailCurrentPage?.staticdata;

      for (const key in this.configUpdates) {
        if (!this.config.hasOwnProperty(key)) {
          this.config[key] = this.configUpdates[key];
        }
      }
      if (!this.config['background-color']) 
        this.config['background-color'] = {
          "gradient_type": "linear-gradient",
          "background": "#8c52ff",
          "value_range": 1,
          "gradient_check": false,
          "value_parameter": 100,
          "gradient_arr": [
            "rgb(0, 0, 255)",
            "rgb(255, 255, 0)"
          ],
          "gradient_direction": ""
        };
      if (!this.config.page)
        this.config.page = {
          "option_background": "color",
          "background_image_restore": "https://img.freepik.com/free-vector/white-abstract-background-design_23-2148825582.jpg?w=1380&t=st=1697510003~exp=1697510603~hmac=4c547175bf91f9c5d38fc8107e6ca7f50fcb185bf867a4b163a257d7b87b39c4",
          "background_color_restore": "transparent",
          "is_upload_image": 0
        };
      this.config.id_block_chatboxs ??= [];
      // Xử lý cho dữ liệu cũ
      if (this.config.id_block_chatbox && !this.config.id_block_chatboxs.includes(this.config.id_block_chatbox)) {
        this.config.id_block_chatboxs.push(this.config.id_block_chatbox);
        this.updateConfig();
      }
      if (!this.staticdata) {
        this.staticdata = this.staticdataUpdates;
        this.updateStaticData();
      }

      if (this.effect_hover) {
        this.effect_hover_data = this.effect_hover.find(
          (e) => e.type == this.staticdata[this.selectedDevice + '_animation_type']
        );
        this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
      }
    }
  }
  
  updateStaticData() {
    if (this.type == 'admin') {
      if (!this.detailCurrentPage.hasOwnProperty('fieldUpdate')) this.detailCurrentPage['fieldUpdate'] = [];
      if (!this.detailCurrentPage['fieldUpdate'].includes(this.selectedDevice + '_staticdata')) this.detailCurrentPage['fieldUpdate'].push(this.selectedDevice + '_staticdata');
      return;
    }
    this.vhQueryAutoWeb
      .updatePage(this.detailCurrentPage._id, {
        staticdata: this.staticdata,
      })
      .then(
        (bool) => {
          // console.log('updatePage', bool);
          this.close();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  updateConfig() {
    if (this.type == 'admin') {
      if (!this.detailCurrentPage.hasOwnProperty('fieldUpdate')) this.detailCurrentPage['fieldUpdate'] = [];
      if (!this.detailCurrentPage['fieldUpdate'].includes(this.selectedDevice + '_config')) this.detailCurrentPage['fieldUpdate'].push(this.selectedDevice + '_config');
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.detailCurrentPage._id)) this.functionService.objectsAndBlocksUpdated.push(this.detailCurrentPage)
      return;
    }
    this.vhQueryAutoWeb
      .updatePage(this.detailCurrentPage._id, {
        [this.selectedDevice + '_config']: this.config,
      })
      .then(
        (bool) => {
          // console.log('updatePage', bool);
          this.close();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  updateClass() {
    if (this.type == 'admin') {
      if (!this.detailCurrentPage.hasOwnProperty('fieldUpdate')) this.detailCurrentPage['fieldUpdate'] = [];
      if (!this.detailCurrentPage['fieldUpdate'].includes(this.selectedDevice + '_class')) this.detailCurrentPage['fieldUpdate'].push(this.selectedDevice + '_class');
      return;
    }
    this.vhQueryAutoWeb
      .updatePage(this.detailCurrentPage._id, {
        [this.selectedDevice + '_class']: this.class,
      })
      .then(
        (bool) => {
          this.close();
        },
        (error) => {
          console.error(error);
        }
      );
  }



  close(): void {
    this.closeConfig.emit(this.detailCurrentPage);
  }

  /**
   * hàm này để cập nhật resolution cho subproject
   */
  updateResolution(reload = false) {
    // document.body.style['zoom'] = (document.getElementById('design_main').clientWidth/this.resolution[this.selectedDevice + '_width']).toString();
    // console.log('zoom',(document.getElementById('design_main').clientWidth/this.resolution[this.selectedDevice + '_width']).toString());

    if (this.type == 'admin') {
      if (!this.detailCurrentPage.hasOwnProperty('fieldUpdate')) this.detailCurrentPage['fieldUpdate'] = [];
      if (!this.detailCurrentPage['fieldUpdate'].includes('resolution')) this.detailCurrentPage['fieldUpdate'].push('resolution');
      return;
    }

    this.vhQueryAutoWeb
      .updateSubProject(this.vhQueryAutoWeb.getlocalSubProject_Working()._id, {
        resolution: this.resolution,
      })
      .then((bool: any) => {
        // console.log('updateSubProject', bool);
        if (reload)
          window.location.reload();
      });
  }

  /** UPLOAD IMAGE */
  openUpload() {
    document.getElementById('upload').click();
    // inputVal;
  }

  onUpload(e) {
    const file = e.target.files[0];
    if (file) {
      this.vhImage
        .getImageFromDesktop(
          file,
          this.image_choosing.src,
          null,
          2000000
        )
        .then(
          (rsp: any) => {
            if (rsp.vcode === 0) {
              this.image_choosing.src = rsp.data;
              // this.updateImagesStickyScroll();
            } else {
              this.functionService.createMessage('error',`Tải ảnh thất bại! Lý do: ${rsp.message}`);
            }
          },
          (error) => {
            console.log('image upload failed', error);
          }
        );
    }
  }

  generateUniqueId() {
    const now = new Date();
    const id = [
      now.getFullYear(),
      (now.getMonth() + 1).toString().padStart(2, '0'),
      now.getDate().toString().padStart(2, '0'),
      now.getHours().toString().padStart(2, '0'),
      now.getMinutes().toString().padStart(2, '0'),
      now.getSeconds().toString().padStart(2, '0'),
      now.getMilliseconds().toString().padStart(3, '0')
    ].join('');
    return id;
  }

  

  isShowContextMenu = false;
  onContextMenu(event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.isShowContextMenu = !this.isShowContextMenu;
    if (this.isShowContextMenu === true) {
      this.nzContextMenuService.create(event, menu);
    } else {
      this.nzContextMenuService.close();
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    if (this.type == 'admin') {
      if (!this.detailCurrentPage.hasOwnProperty('fieldUpdate')) this.detailCurrentPage['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.detailCurrentPage._id)) this.functionService.objectsAndBlocksUpdated.push(this.detailCurrentPage)
      if (!this.detailCurrentPage['fieldUpdate'].includes(this.selectedDevice+'_class')) this.detailCurrentPage['fieldUpdate'].push(this.selectedDevice+'_class')
      if (!this.detailCurrentPage['fieldUpdate'].includes(this.selectedDevice+'_config')) this.detailCurrentPage['fieldUpdate'].push(this.selectedDevice+'_config')
      return;
    }

    this.customize = event;

    if (this.config['animation-selected'].id !== '000000') {
      this.openViewAll(this.style_fields[0]);
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['page']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient = this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['page']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['page']['background-image'] = "none";
    }
    this.updateConfig();
    this.updateClass();
  }
}
